"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, useQuery } from "@opensea/graphql";
import { useCallback, useState } from "react";
import { NETWORK_ONLY_OPERATION_CONTEXT } from "../../../constants";
import { useAddress } from "../../../polychain/hooks/useAddress";
import { useEndFlowOnAccountChange } from "../../hooks/useEndFlowOnAccountChange";
import { CancelOrderFlowContent } from "./CancelOrderFlowContent";
import { CancelOrderFlowContentFragment } from "./CancelOrderFlowContent.fragment";
import { CancelOrderFlowSkeleton } from "./CancelOrderFlowSkeleton";
const CancelOrderIdsFlow = t0 => {
  const $ = _c(14);
  const {
    orderIds
  } = t0;
  const address = useAddress();
  const [gaslessCancelEligibleOrders, setGaslessCancelEligibleOrders] = useState(true);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setGaslessCancelEligibleOrders(false);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleForceOnchainCancellation = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = graphql("\n        query CancelOrderIdsFlowQuery(\n          $orderIds: [String!]!\n          $address: Address!\n          $gaslessCancelEligibleOrders: Boolean!\n        ) {\n          cancelOrders(\n            orderIds: $orderIds\n            address: $address\n            gaslessCancelEligibleOrders: $gaslessCancelEligibleOrders\n          ) {\n            ...CancelOrderFlowContent\n          }\n        }\n      ", [CancelOrderFlowContentFragment]);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = address ?? "";
  let t4;
  if ($[2] !== gaslessCancelEligibleOrders || $[3] !== orderIds || $[4] !== t3) {
    t4 = {
      orderIds,
      address: t3,
      gaslessCancelEligibleOrders
    };
    $[2] = gaslessCancelEligibleOrders;
    $[3] = orderIds;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = !address;
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = {
      query: t2,
      variables: t4,
      context: NETWORK_ONLY_OPERATION_CONTEXT,
      pause: t5
    };
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const [t7] = useQuery(t6);
  const {
    data,
    fetching
  } = t7;
  if (fetching) {
    let t8;
    if ($[9] !== orderIds.length) {
      t8 = <CancelOrderFlowSkeleton count={orderIds.length} />;
      $[9] = orderIds.length;
      $[10] = t8;
    } else {
      t8 = $[10];
    }
    return t8;
  }
  if (!data) {
    throw new Error("There was a problem with cancelling.");
  }
  let t8;
  if ($[11] !== data.cancelOrders || $[12] !== gaslessCancelEligibleOrders) {
    t8 = <CancelOrderFlowContent data={data.cancelOrders} gaslessCancelEligibleOrders={gaslessCancelEligibleOrders} onForceOnchainCancellation={handleForceOnchainCancellation} />;
    $[11] = data.cancelOrders;
    $[12] = gaslessCancelEligibleOrders;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};
const CancelListingsForItemsFlow = t0 => {
  const $ = _c(10);
  const {
    items
  } = t0;
  const address = useAddress();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = graphql("\n        query CancelListingsForItemsFlowQuery(\n          $items: [ItemIdentifierInput!]!\n          $address: Address!\n        ) {\n          cancelItemsListings(items: $items, address: $address) {\n            ...CancelOrderFlowContent\n          }\n        }\n      ", [CancelOrderFlowContentFragment]);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== items) {
    t2 = items.map(_temp);
    $[1] = items;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = address;
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = {
      query: t1,
      variables: {
        items: t2,
        address: t3
      },
      context: NETWORK_ONLY_OPERATION_CONTEXT
    };
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const [t5] = useQuery(t4);
  const {
    data,
    fetching
  } = t5;
  if (fetching) {
    let t6;
    if ($[6] !== items.length) {
      t6 = <CancelOrderFlowSkeleton count={items.length} />;
      $[6] = items.length;
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    return t6;
  }
  if (!data) {
    throw new Error("There was a problem with cancelling.");
  }
  let t6;
  if ($[8] !== data.cancelItemsListings) {
    t6 = <CancelOrderFlowContent data={data.cancelItemsListings} />;
    $[8] = data.cancelItemsListings;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
export const CancelOrderFlow = props => {
  const $ = _c(4);
  useEndFlowOnAccountChange();
  if ("orderIds" in props) {
    let t0;
    if ($[0] !== props) {
      t0 = <CancelOrderIdsFlow {...props} />;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] !== props) {
    t0 = <CancelListingsForItemsFlow {...props} />;
    $[2] = props;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
function _temp(t0) {
  const {
    chain,
    contractAddress,
    tokenId
  } = t0;
  return {
    chain: chain.identifier,
    contractAddress,
    tokenId
  };
}